<template>
    <div class="login-container">
        <img class="leq-logo" src="logo-leq-horiz.bmp" 
        alt="Logo Leblon Equities">
        <div class="login">
            <div class="login-card">
                <div class="login-header">
                    <h1 class="header">Resetar Senha</h1>
                </div>
                <div class="login-container">
                    <el-input v-model="email" placeholder="Email" @blur="checkEmail"></el-input><br>
                </div>
                <el-alert v-show="visible" :title="errorMessage" type="error" @close="changeVisible" show-icon center></el-alert>
                <div class="login-container">
                    <el-button class="connect" type="primary" @click="passwordEmail" round>Enviar e-mail</el-button>
                </div>
            </div>
            
            <div class="login-footer">
                <p class="footer">Voltar para a página de <router-link to="/login">login</router-link>.</p>
                
                <p class="footer">Não possui uma conta?<br>Você pode criar uma <router-link to="/signUp">aqui</router-link>.</p>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import firebase from 'firebase/app'

    export default {
        name: 'login',
        data() {
            return {
                email: '',
                errorMessage: '',
                descriptionError: '',
                visible: false,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                errorCode: {
                    "auth/invalid-email": "E-mail fora do formato padrão.",
                    "auth/user-not-found": "Não foi encontrado usuário com este endereço de e-mail.",
                    "auth/missing-android-pkg-name": "Erro. Contate o administrador. + auth/missing-android-pkg-name",
                    "auth/missing-continue-uri": "Erro. Contate o administrador. + auth/missing-android-pkg-name",
                    "auth/missing-ios-bundle-id": "Erro. Contate o administrador. + auth/missing-android-pkg-name",
                    "auth/invalid-continue-uri": "Erro. Contate o administrador. + auth/missing-android-pkg-name",
                    "auth/unauthorized-continue-uri": "Erro. Contate o administrador. + auth/missing-android-pkg-name",
                }
            };
        },
        methods: {
            changeVisible() {
                this.visible = false
            },
            checkEmail() {
                this.visible =  !this.reg.test(this.email) && (this.email != "");
                this.errorMessage = "E-mail fora do formato padrão."
            },
            passwordEmail() {
                // this.$alert('teste')
                firebase.auth().sendPasswordResetEmail(this.email).then(
                    () => {
                        this.$alert('Foi enviado um e-mail de alteração de senha.')
                    },
                    (err) => {
                        this.errorMessage = this.errorCode[err.code]
                        this.visible = true
                    }
                )
            }
        }
    }
</script>

<style scoped>
    .leq-logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 70px 0;
    }
    .login {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin: 0 auto;
    }
    .login-card {
        width: 60%;
        text-align: center;
        justify-content: center;
    }
    .header {
        align-items: center;
        justify-content: center;
    }
    .login-email-senha{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .login-container {
        margin-bottom: 15px;
    }
    .login-header {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .connect {
        margin-top: 10px;
        width: 100%;
        font-size: 12.5px;
        line-height: 0.5;
        cursor: pointer;
    }
    p {
        margin-top: 20px;
        /*font-size: 13px;*/
        text-align: center;
    }
    p a {
        text-decoration: underline;
        cursor: pointer;
    }
    .login-header h1 {
        font-family: Merriweather, serif;
        font-weight: 500;
        line-height: 1.35;
        color: #505050;
    }
    .login-footer {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .footer {
        align-items: center;
        justify-content: center;
    }
    .login-footer p {
        font-family: Merriweather, serif;
        font-weight: 50;
        line-height: 1.35;
        color: #505050;
    }
</style>
